module.exports = __webpack_public_path__ + "img/singup5.7e5bf367.jpg";